import styled from "styled-components";

export const SearchBoxMobileIconDefaultBox = styled.i`
        display: block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 1rem;
        width: 3rem;
        height: 3rem;
        background-image: url("${props => props.theme.assets.images.SpriteSheetPC1920_png.toString()}");
        background-repeat: no-repeat;
        background-position: -138px -626px;
        z-index: 2;
`;